
webpack.register(
    'modules/player-road-to-erin-hills/player-road-to-erin-hills',
    function() {
        return import('modules/player-road-to-erin-hills/player-road-to-erin-hills');
    },
    true
);